module.exports = __webpack_public_path__ + "img/1498560672.83288796.jpg";